import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface TabsProps<T extends string> {
  tabs: { value: T; label: ReactNode; badge?: ReactNode }[];
  value: T;
  onChange: (v: T) => void;
  className?: string;
}

export function Tabs<T extends string>({ tabs, value, onChange, className }: TabsProps<T>) {
  return (
    <div className={cn('border-b border-slate-200 flex gap-1 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden', className)} role="tablist">
      {tabs.map((t) => {
        const active = t.value === value;
        return (
          <button
            key={t.value}
            role="tab"
            aria-selected={active}
            onClick={() => onChange(t.value)}
            className={cn(
              'px-3 py-2 text-sm font-medium border-b-2 -mb-px transition-colors whitespace-nowrap',
              active
                ? 'border-bb-navy text-bb-navy'
                : 'border-transparent text-slate-500 hover:text-bb-navy',
            )}
          >
            <span className="inline-flex items-center gap-2">
              {t.label}
              {t.badge}
            </span>
          </button>
        );
      })}
    </div>
  );
}
